
import { defineComponent, PropType, computed } from 'vue'

export default defineComponent({
  name: 'admin-data-table',
  props: {
    columns: {
      type: Array as PropType<Array<{ title: string; dataIndex?: string; key: string; [k: string]: unknown }>>,
      required: true,
    },
    dataSource: {
      type: Array as PropType<Array<Record<string, unknown>>>,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
    current: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 20,
    },
    emptyText: {
      type: String,
      default: '暂无数据',
    },
    rowKey: {
      type: [String, Function] as PropType<string | ((record: Record<string, unknown>) => string)>,
      default: 'id',
    },
    rowSelection: {
      type: Object as PropType<Record<string, unknown> | undefined>,
      default: undefined,
    },
  },
  emits: ['change'],
  setup(props, { emit }) {
    const paginationCurrent = computed({
      get: () => props.current,
      set: (val: number) => emit('change', val, props.pageSize),
    })

    const paginationPageSize = computed({
      get: () => props.pageSize,
      set: (val: number) => emit('change', 1, val),
    })

    return {
      paginationCurrent,
      paginationPageSize,
    }
  },
})
